import { useEffect } from 'react';
import { values } from '../constants/defaults';

export interface priceProps {
  partNumber: string;
  pricingIndicator: string;
  pricingModel: number;
  scaleQtyPrice: [
    {
      qty: number;
      price: number;
    },
  ];
}

export const setROI = (
  numberOfProcessToAutomate: number,
  currentNumberOfHoursPerWeek: number,
  currentFullTimeEmployeeCost: number,
  errorRate: number,
  setShowContactUs: React.Dispatch<React.SetStateAction<boolean>>,
  setRoiValue: React.Dispatch<React.SetStateAction<number>>,
  setRecommendedAttendedBots: React.Dispatch<React.SetStateAction<number>>,
  setRecommendedUnattendedBots: React.Dispatch<React.SetStateAction<number>>,
  setRecommendedEnvironments: React.Dispatch<React.SetStateAction<number>>,
  setROIPercentage: React.Dispatch<React.SetStateAction<number>>,
  setMonthlyTimeSavings: React.Dispatch<React.SetStateAction<number>>,
  setReworkSavings: React.Dispatch<React.SetStateAction<number>>,
  cost: number,
) => {
  useEffect(() => {
    // Total weekly hours
    const totalWeeklyHours =
      numberOfProcessToAutomate * currentNumberOfHoursPerWeek;
    // Hours per process
    const botsPerProcess = Math.ceil(
      currentNumberOfHoursPerWeek / values.botsPerWeek,
    );
    //Recommended bots
    const recommendedBoots = botsPerProcess * numberOfProcessToAutomate;
    let attendedRobots = 0,
      unattendedRobots = 0,
      numberOfEnvironments = 0;
    if (recommendedBoots < 4) {
      attendedRobots = 2;
      unattendedRobots = 1;
    } else if (recommendedBoots >= 4 && recommendedBoots <= 20) {
      attendedRobots = 2;
      unattendedRobots = recommendedBoots - 2;
    } else if (recommendedBoots > 20) {
      attendedRobots = Math.ceil(recommendedBoots * 0.1);
      unattendedRobots = Math.ceil(recommendedBoots * 0.9);
    }
    // Recommended environments
    numberOfEnvironments =
      numberOfProcessToAutomate >= 3 ? 3 : numberOfProcessToAutomate;
    setRecommendedAttendedBots(attendedRobots);
    setRecommendedUnattendedBots(unattendedRobots);
    setRecommendedEnvironments(numberOfEnvironments);
    //Savings
    const totalYearlyHours = totalWeeklyHours * 52;
    const totalMonthlyHours = totalWeeklyHours * 4.2;
    const fteHourlyCost = (currentFullTimeEmployeeCost * 1000) / 52 / 40;
    const costSavings = fteHourlyCost * (totalYearlyHours * 0.9);
    const reworkHours = (totalYearlyHours * errorRate) / 100;
    const reworkSavings = fteHourlyCost * reworkHours;
    setReworkSavings(reworkSavings);
    const totalSavings = costSavings;
    setRoiValue(totalSavings);
    let roiPercentage = 0;
    if (cost) {
      roiPercentage = (totalSavings / (cost * 12)) * 100;
    }
    setROIPercentage(roundToTwo(roiPercentage));

    const monthlyTimeSavings = Math.round(
      (totalMonthlyHours + reworkHours / 12) * 0.9,
    );
    setMonthlyTimeSavings(monthlyTimeSavings);
    if (monthlyTimeSavings <= 0) {
      setShowContactUs(true);
    } else {
      setShowContactUs(false);
    }
  }, [
    currentNumberOfHoursPerWeek,
    currentFullTimeEmployeeCost,
    errorRate,
    numberOfProcessToAutomate,
    cost,
  ]);

  // To round to 2 decimals
  const roundToTwo = (num: number) => {
    return +Math.round(Number.parseInt(num * 100 + 'e+4')) / 100;
  };
};
